module.exports = __webpack_public_path__ + "img/carrito_vacio.22beec42.png";